import API from '../utils/request'
export function deleteSetting (data) {
  return API.post('/management/template/file/file/delete', data)
  // return API({
  //   url: '/management/template/file/file/delete',
  //   method: 'post',
  //   data
  // })
}
export function createSetting (data) {
  return API.post('/management/upYun/uploadImg', data)
}
export function createVideo (data) {
  return API.post('/management/upYun/uploadVideo', data)
}
